const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/LoginPage/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        cancelBtnLabel: 'Abbrechen',
        didntReceiveCode: 'Keinen SMS-Code erhalten?',
        invitationCodeHint: 'Code des Aufgebotsschreibens',
        loginBtnLabelCode: 'Weiter',
        loginBtnLabelSMS: 'Senden',
        smsCodeHint: 'SMS-Code',
        invitationCodeEmpty: 'Bitte geben Sie den Code Ihres Aufgebotsschreibens ein',
        smsCodeEmpty: 'Bitte geben Sie Ihren SMS-Code ein.',
        invitationCodeBad: 'Dies ist kein gültiger Code',
        messageOnStageInvitationCode: 'Bitte geben Sie den Zugangscode ein. Diesen finden Sie auf dem Aufgebot.',
        messageOnStageSMSCode: 'Bitte geben Sie den Code ein, den Sie per SMS an (###FON###) erhalten haben',
        QRCodeWithInvitationCode: 'Bitte QR-Code abscannen',
        QRCodeBackBtn: 'Zurück',
        ariaQRCodeWithInvitationCode: 'QR-Code mit enthaltenem Einladungs-Code abscannen',
        smsCodeAttemptsLeft:
            '{count, plural,\n            one {Sie haben noch # Versuch übrig.}\n            other {Sie haben noch # Versuche übrig.}\n          }',
        smsCodeNoAttemptsLeft: 'Keine Versuche mehr übrig. Starten Sie den Login Prozess neu.',
        smsCodeExpired: 'Der SMS-Code ist leider abgelaufen.',
        restartLoginProcess: '{link}, um direkt zur Startseite zu gelangen und den Login neu zu starten.',
        clickHere: 'Klicken Sie hier',
    },
    __RELATIVE_SOURCE_FILE__
);
